import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class ConfigService {

  constructor(private http: HttpClient) {}

  loadConfig(): Promise<void> {
    return this.http.get<{apiRoot: string, theme?: {[key: string]: string}}>('/assets/config.json')
      .toPromise()
      .then((config: any) => {
        // Directly update the environment object
        environment.apiRoot = config.apiRoot;
        if (config.theme) {
          const root = document.documentElement;
          for (const key in config.theme) {
            if (Object.prototype.hasOwnProperty.call(config.theme, key)) {
              root.style.setProperty(`--${key}`, config.theme[key]);
            }
          }
        }
      })
      .catch(() => {
        console.warn('Config not found, using default');
      });
  }
}